import { MESSAGES_FAILURE, MESSAGES_SUCCESS, MESSAGE_UPDATE, UPDATE_MESSAGE_STATUS, ADD_MESSAGE_REACTION, REMOVE_MESSAGE_REACTION } from 'redux/types/conversations'
import { SET_FILTERED_MESSAGES } from './messageFilters'

export default function messages(state = [], action) {
  switch (action.type) {
    case MESSAGES_SUCCESS: {
      if (!action.concat) return action.messages
      if (action.isPoll || action.up) return [].concat(action.messages, state)
      return [].concat(state, action.messages)
    }
    case MESSAGES_FAILURE: {
      return state
    }
    case SET_FILTERED_MESSAGES: {
      return [].concat(action.messages)
    }
    case MESSAGE_UPDATE: {
      const messageIndex = state.findIndex(message => message._id === action.message._id)
      return Object.assign([...state], {
        [messageIndex]: { ...state[messageIndex], ...action.message }
      })
    }
    case UPDATE_MESSAGE_STATUS: {
      const { messageId, status, errorMessage } = action.payload
      const messageIndex = state.findIndex(message => message._id === messageId)

      return Object.assign([...state], {
        [messageIndex]: { ...state[messageIndex], status, errorMessage }
      })
    }
    case ADD_MESSAGE_REACTION: {
      return state
    }
    case REMOVE_MESSAGE_REACTION: {
      return state
    }
    default: {
      return state
    }
  }
}
